<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-header">
        <div class="cat-ear left-ear"></div>
        <div class="cat-ear right-ear"></div>
        <div class="login-image">
          <img src="../assets/logo.png" alt="哈基米 Logo">
        </div>
        <div class="login-title">登录</div>
      </div>
      
      <form @submit.prevent="handleLogin" class="login-form">
        <div class="form-group" :class="{ 'has-error': errors.username }">
          <div class="input-wrapper">
            <span class="input-icon">👤</span>
            <input
              type="text"
              id="username"
              v-model="form.username"
              placeholder="请输入用户名"
              @focus="clearError('username')"
              autocomplete="username"
            />
          </div>
          <span class="error-msg" v-if="errors.username">{{ errors.username }}</span>
        </div>
        
        <div class="form-group" :class="{ 'has-error': errors.password }">
          <div class="input-wrapper">
            <span class="input-icon">🔑</span>
            <input
              :type="showPassword ? 'text' : 'password'"
              id="password"
              v-model="form.password"
              placeholder="请输入密码"
              @focus="clearError('password')"
              autocomplete="current-password"
            />
            <span 
              class="password-toggle" 
              @click="showPassword = !showPassword"
              :title="showPassword ? '隐藏密码' : '显示密码'"
            >
              {{ showPassword ? '👁️‍🗨️' : '👁️' }}
            </span>
          </div>
          <span class="error-msg" v-if="errors.password">{{ errors.password }}</span>
        </div>
        
        <div class="form-group" v-if="loginError">
          <div class="global-error">
            <span class="error-icon">❌</span>
            {{ loginError }}
          </div>
        </div>
        
        <div class="form-actions">
          <button type="submit" class="login-button" :disabled="isLoading">
            <span v-if="isLoading" class="loading-icon">⏳</span>
            <span v-else>{{ isLoading ? '登录中...' : '登 录' }}</span>
          </button>
          <a href="/" class="back-link">返回首页</a>
        </div>
      </form>
    </div>
    
    <div class="login-footer">
      <p>哈基米表情包收集 © 2025</p>
    </div>
  </div>
</template>

<script>
import authService from '../services/auth';

export default {
  name: 'LoginView',
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      errors: {
        username: '',
        password: ''
      },
      loginError: '',
      isLoading: false,
      showPassword: false
    };
  },
  methods: {
    clearError(field) {
      this.errors[field] = '';
      this.loginError = '';
    },
    
    validateForm() {
      let isValid = true;
      
      // 验证用户名
      if (!this.form.username.trim()) {
        this.errors.username = '请输入用户名';
        isValid = false;
      }
      
      // 验证密码
      if (!this.form.password) {
        this.errors.password = '请输入密码';
        isValid = false;
      } else if (this.form.password.length < 6) {
        this.errors.password = '密码长度不能少于6位';
        isValid = false;
      }
      
      return isValid;
    },
    
    async handleLogin() {
      // 清除所有错误信息
      this.loginError = '';
      this.errors = {
        username: '',
        password: ''
      };
      
      // 表单验证
      if (!this.validateForm()) {
        return;
      }
      
      this.isLoading = true;
      
      try {
        // 添加按钮动画效果
        document.querySelector('.login-button').classList.add('loading-animation');
        
        // 调用登录API
        const success = await authService.login(
          this.form.username,
          this.form.password
        );
        
        if (success) {
          // 登录成功，显示成功状态
          document.querySelector('.login-button').classList.remove('loading-animation');
          document.querySelector('.login-button').classList.add('success-animation');
          
          // 显示登录成功提示
          const successElement = document.createElement('div');
          successElement.className = 'login-success-message';
          successElement.innerHTML = '<span class="success-icon">✅</span> 登录成功，即将返回首页...';
          document.body.appendChild(successElement);
          
          // 延迟跳转，让用户看到成功提示
          setTimeout(() => {
            window.location.href = '/';
          }, 1500);
        } else {
          this.loginError = '登录失败，请检查用户名和密码';
          document.querySelector('.login-button').classList.remove('loading-animation');
        }
      } catch (error) {
        console.error('登录出错:', error);
        document.querySelector('.login-button').classList.remove('loading-animation');
        
        // 根据错误状态设置不同的错误信息
        if (error.response && error.response.status === 401) {
          this.loginError = '用户名或密码错误';
        } else {
          this.loginError = '登录失败，请稍后重试';
        }
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.login-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-image: url('../assets/bg.png');
  background-repeat: repeat;
  position: relative;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.login-box {
  width: 90%;
  max-width: 400px;
  background-color: #fff;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  overflow: hidden;
  padding-bottom: 30px;
  position: relative;
  animation: fadeIn 0.5s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-20px); }
  to { opacity: 1; transform: translateY(0); }
}

.login-header {
  background-color: #f0f9f0;
  padding: 30px 20px;
  text-align: center;
  border-bottom: 1px solid #e8f5e9;
  position: relative;
}

.cat-ear {
  position: absolute;
  top: -5px;
  width: 30px;
  height: 30px;
  background-color: #42b983;
  border-radius: 50% 50% 0 0;
  z-index: 2;
  animation: earWiggle 8s infinite;
}

.left-ear {
  left: 30%;
  transform: rotate(-30deg);
  animation-delay: 0.5s;
}

.right-ear {
  right: 30%;
  transform: rotate(30deg);
  animation-delay: 1s;
}

@keyframes earWiggle {
  0%, 90%, 100% { transform: rotate(-30deg); }
  95% { transform: rotate(-45deg); }
}

@keyframes rightEarWiggle {
  0%, 90%, 100% { transform: rotate(30deg); }
  95% { transform: rotate(45deg); }
}

.right-ear {
  animation: rightEarWiggle 8s infinite;
}

.login-image {
  width: 80px;
  height: 80px;
  margin: 0 auto 15px;
  border-radius: 50%;
  overflow: hidden;
  border: 3px solid #42b983;
  box-shadow: 0 3px 10px rgba(66, 185, 131, 0.2);
}

.login-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.login-title {
  color: #42b983;
  margin: 0;
  font-size: 22px;
  text-align: center;
}

.login-form {
  padding: 25px 30px;
}

.form-group {
  margin-bottom: 20px;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s;
}

.input-wrapper:focus-within {
  border-color: #42b983;
  box-shadow: 0 0 0 2px rgba(66, 185, 131, 0.2);
}

.form-group.has-error .input-wrapper {
  border-color: #ff5252;
}

.input-icon {
  padding: 0 12px;
  background-color: #f9f9f9;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #eee;
  font-size: 18px;
}

input {
  flex: 1;
  padding: 12px 15px;
  border: none;
  font-size: 16px;
  outline: none;
}

.password-toggle {
  padding: 0 12px;
  cursor: pointer;
  color: #999;
  font-size: 20px;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.password-toggle:hover {
  color: #666;
}

.error-msg {
  color: #ff5252;
  font-size: 12px;
  margin-top: 5px;
  display: block;
  padding-left: 5px;
}

.global-error {
  background-color: #ffebee;
  color: #ff5252;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 15px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.error-icon {
  font-size: 16px;
}

.form-actions {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login-button {
  width: 100%;
  padding: 14px;
  background-color: #42b983;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-button:hover:not(:disabled) {
  background-color: #3da576;
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(66, 185, 131, 0.3);
}

.login-button:active:not(:disabled) {
  transform: translateY(0);
}

.login-button:disabled {
  background-color: #a8d5c2;
  cursor: not-allowed;
}

.login-button.loading-animation {
  animation: buttonLoading 1s infinite;
}

.login-button.success-animation {
  background-color: #4caf50;
  color: white;
}

@keyframes buttonLoading {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

.loading-icon {
  animation: spin 1.5s infinite linear;
  display: inline-block;
  margin-right: 8px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.back-link {
  margin-top: 16px;
  color: #666;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.back-link::before {
  content: '←';
  font-size: 18px;
}

.back-link:hover {
  color: #42b983;
}

.login-footer {
  margin-top: 30px;
  text-align: center;
  padding: 20px;
  color: #666;
  font-size: 12px;
}

/* 登录成功消息 */
.login-success-message {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 15px 25px;
  border-radius: 8px;
  font-size: 16px;
  z-index: 2000;
  display: flex;
  align-items: center;
  gap: 10px;
  animation: fadeInOut 2s forwards;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
}

.success-icon {
  font-size: 20px;
}

@keyframes fadeInOut {
  0% { opacity: 0; transform: translate(-50%, -50%) scale(0.9); }
  20% { opacity: 1; transform: translate(-50%, -50%) scale(1); }
  80% { opacity: 1; transform: translate(-50%, -50%) scale(1); }
  100% { opacity: 0; transform: translate(-50%, -50%) scale(0.9); }
}

/* 添加登录响应式设计 */
@media (max-width: 576px) {
  .login-box {
    width: 100%;
    border-radius: 12px;
  }
  
  .login-form {
    padding: 20px;
  }
  
  .login-title {
    font-size: 20px;
  }
}
</style>